import * as React from "react"

import { cn } from "../../lib/utils"

function Link({ className, ...props }: React.ComponentProps<"a">) {
  return (
    <a
      className={cn(
        "[color:var(--color-text-link)] [cursor:pointer] [font-weight:500] [text-decoration:none] hover:[color:var(--color-text-link-strong)] hover:[text-decoration:none]",
        className
      )}
      {...props}
    />
  )
}

export { Link }
